import { useQuery } from '@apollo/client';
import { GET_USER_ENTITY_PERMISSIONS } from '@frontend/app/queries';

export function useGetUserEntityPermissions(options) {
  return useQuery(GET_USER_ENTITY_PERMISSIONS, options);
}
